import { useEffect, useState } from 'react';

import { getAbTestV2 } from 'dibs-buyer-layout/exports/clientABTestV2';

export const useExposedReturnsClientVariant = (): boolean | null => {
    const [isExposedReturnsClientVariant, setIsExposedReturnsClientVariant] = useState<
        boolean | null
    >(null);

    useEffect(() => {
        setIsExposedReturnsClientVariant(getAbTestV2('ReturnsonPDP')?.variant === 'variant');
    }, []);

    return isExposedReturnsClientVariant;
};
